import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Matter from '../../entities/matter';
import Deadline from '../../entities/deadline';
import Invoice from '../../entities/invoice';
import MatterStage from '../../entities/matterStage';
import Transaction from '../../entities/transaction';
import Task from '../../entities/task';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
import Participant from '../../entities/participant';
import RedFlag from '../../entities/redFlag';
export function deleteMatter(matter: Matter, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = matter.id;}
const _work = workingSet();
store.getState().deadlines.getMappingFor('matterId', matter.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.matterId === matter.id) {
_deadline.matterId = '';

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
store.getState().invoices.getMappingFor('matterId', matter.id).filter(invoiceTemp => invoiceTemp.status !== 'D').forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.matterIds = _invoice.matterIds?.filter(id => id !== matter.id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});
store.getState().matterStages.getMappingFor('matterId', matter.id).filter(matterStageTemp => matterStageTemp.status !== 'D').forEach(matterStageTemp => {
const _matterStage = ((_work.get('matterStage:' + matterStageTemp.id) ?? matterStageTemp) as MatterStage).clone();
_matterStage.status = 'U';
_matterStage.addedOn = newHRTimestamp();
_matterStage.addedBy = getCurrentUserId();
_matterStage.importSource = targetImportSource;
_matterStage.importId = mergeId;
if (_matterStage.matterId === matter.id) {
_matterStage.matterId = '';

}
_work.set('matterStage:' + _matterStage.id, _matterStage);
store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
});
store.getState().transactions.getMappingFor('matterId', matter.id).filter(transactionTemp => transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_transaction.matterIds = _transaction.matterIds?.filter(id => id !== matter.id) || [];

_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.sourceType === 'M' && transactionTemp.source === matter.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();

_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.targetType === 'M' && transactionTemp.target === matter.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();

_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.status !== 'D' && transactionTemp.hasOwnProperty('paymentDistribution')).filter(transactionTemp => !!transactionTemp.paymentDistribution?.some(item => item.matterId === matter.id)).forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
if (!!_transaction.paymentDistribution) {_transaction.paymentDistribution = [..._transaction.paymentDistribution].filter(f => f.matterId !== matter.id);} else {_transaction.paymentDistribution = [];}
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Task>('tasks').filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns')).filter(taskTemp => !!taskTemp.tieIns?.some(f => {return 'Matter' === f.entity && f.id === matter.id;})).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.tieIns = [...(_task.tieIns || [])].filter(f => !('Matter' === f.entity && f.id === matter.id));
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
matter.status = 'D';
matter.addedOn = newHRTimestamp();
matter.addedBy = getCurrentUserId();
matter.importSource = targetImportSource;
matter.importId = mergeId;
store.dispatch(Actions.MatterActions.removeMatterQueue(matter));
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'matter' && documentTemp.entityId === matter.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'D';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'matter' && commentTemp.entityId === matter.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.status = 'D';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
});
findAll<Participant>('participants').filter(participantTemp => participantTemp.entityType === 'matter' && participantTemp.entityId === matter.id && participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'D';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.removeParticipantQueue(_participant));
});
findAll<RedFlag>('redFlags').filter(redFlagTemp => redFlagTemp.entityType === 'matter' && redFlagTemp.entityId === matter.id && redFlagTemp.status !== 'D').forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
_redFlag.status = 'D';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;
_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.removeRedFlagQueue(_redFlag));
});
}
export function replaceMatter(matter: Matter, replaceWith: Matter, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = matter.id;}
const _work = workingSet();
store.getState().deadlines.getMappingFor('matterId', matter.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.matterId === matter.id) {
_deadline.matterId = replaceWith.id;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
store.getState().invoices.getMappingFor('matterId', matter.id).filter(invoiceTemp => invoiceTemp.status !== 'D').forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.matterIds = _invoice.matterIds?.map(id => (id === matter.id) ? replaceWith.id : id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});
store.getState().matterStages.getMappingFor('matterId', matter.id).filter(matterStageTemp => matterStageTemp.status !== 'D').forEach(matterStageTemp => {
const _matterStage = ((_work.get('matterStage:' + matterStageTemp.id) ?? matterStageTemp) as MatterStage).clone();
_matterStage.status = 'U';
_matterStage.addedOn = newHRTimestamp();
_matterStage.addedBy = getCurrentUserId();
_matterStage.importSource = targetImportSource;
_matterStage.importId = mergeId;
if (_matterStage.matterId === matter.id) {
_matterStage.matterId = replaceWith.id;

}
_work.set('matterStage:' + _matterStage.id, _matterStage);
store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
});
store.getState().transactions.getMappingFor('matterId', matter.id).filter(transactionTemp => transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_transaction.matterIds = _transaction.matterIds?.map(id => (id === matter.id) ? replaceWith.id : id) || [];

_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.sourceType === 'M' && transactionTemp.source === matter.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.source = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.targetType === 'M' && transactionTemp.target === matter.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.target = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.status !== 'D' && transactionTemp.hasOwnProperty('paymentDistribution')).filter(transactionTemp => !!transactionTemp.paymentDistribution?.some(item => item.matterId === matter.id)).forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
if (!!_transaction.paymentDistribution) {_transaction.paymentDistribution = [..._transaction.paymentDistribution].map(f => {if (f.matterId === matter.id) {const _f = {...f}; _f.matterId = replaceWith.id; return _f;} else return f;});} else {_transaction.paymentDistribution = [];}
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Task>('tasks').filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns')).filter(taskTemp => !!taskTemp.tieIns?.some(f => {return 'Matter' === f.entity && f.id === matter.id;})).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.tieIns = [...(_task.tieIns || [])].map(f => {if ('Matter' === f.entity && f.id === matter.id) {const _f = {...f}; _f.id = replaceWith.id; return _f;} else return f;});
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'matter' && documentTemp.entityId === matter.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.entityId = replaceWith.id;
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'matter' && commentTemp.entityId === matter.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.entityId = replaceWith.id;
_comment.status = 'U';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
});
findAll<Participant>('participants').filter(participantTemp => participantTemp.entityType === 'matter' && participantTemp.entityId === matter.id && participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.entityId = replaceWith.id;
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
findAll<RedFlag>('redFlags').filter(redFlagTemp => redFlagTemp.entityType === 'matter' && redFlagTemp.entityId === matter.id && redFlagTemp.status !== 'D').forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
_redFlag.entityId = replaceWith.id;
_redFlag.status = 'U';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;
_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
});
return matter;
}
export function deleteImpactMatter(matter: Matter) {
const impacts: string[] = [];
const state = store.getState();
const deadlineMatterIdImpact = state.deadlines.getMappingFor('matterId', matter.id).filter(deadline => deadline.status !== 'D');
deadlineMatterIdImpact.forEach(() => impacts.push('deadlines*'));
const invoiceMatterIdsImpact = state.invoices.getMappingFor('matterId', matter.id).filter(invoice => invoice.status !== 'D');
invoiceMatterIdsImpact.forEach(() => impacts.push('invoices'));
const matterStageMatterIdImpact = state.matterStages.getMappingFor('matterId', matter.id).filter(matterStage => matterStage.status !== 'D');
matterStageMatterIdImpact.forEach(() => impacts.push('matterStages*'));
const transactionMatterIdsImpact = state.transactions.getMappingFor('matterId', matter.id).filter(transaction => transaction.status !== 'D');
transactionMatterIdsImpact.forEach(() => impacts.push('transactions*'));
const transactionSourceTypeImpact = findAll<Transaction>('transactions').filter(transaction => transaction.sourceType === 'M' && transaction.source === matter.id && transaction.status !== 'D');
transactionSourceTypeImpact.forEach(() => impacts.push('transactions'));
const transactionTargetTypeImpact = findAll<Transaction>('transactions').filter(transaction => transaction.targetType === 'M' && transaction.target === matter.id && transaction.status !== 'D');
transactionTargetTypeImpact.forEach(() => impacts.push('transactions*'));
const transactionPaymentDistributionImpact = findAll<Transaction>('transactions').filter(transaction => transaction.status !== 'D' && transaction.hasOwnProperty('paymentDistribution')).filter(transaction => !!transaction.paymentDistribution?.some(item => item.matterId === matter.id));
transactionPaymentDistributionImpact.forEach(() => impacts.push('transactions'));
const taskTieInsImpact = findAll<Task>('tasks').filter(task => task.status !== 'D' && task.hasOwnProperty('tieIns')).filter(task => !!task.tieIns?.some(f => {return 'Matter' === f.entity && f.id === matter.id;}));
taskTieInsImpact.forEach(() => impacts.push('tasks'));
return util.countDistinct(impacts);
}
